export default __webpack_public_path__ + "static/ogp-c980fdb9cf803e5c724a7366a5b5bb73.png";